<template>

    <div class="tik-tok">

        <lottie-loader :size="32"></lottie-loader>

    </div>

</template>

<script>
import LottieLoader from '../components/lottie/LottieLoader'
import UserAgent from '../modules/userAgent'

export default {

    name: 'tik-tok-redirect',

    components: {LottieLoader},

    created() {
        this.tiktokPixel()
    },

    mounted() {
        // direct redirect to the play store
        const ttclid = this.getCookie('ttclid') // TikTok Click ID
        if(UserAgent.is.ios()) {
            window.location.href = `https://cleanfox.app.link/SzXDwcINA3?ttclid=${ttclid}`
        } else if(UserAgent.is.android()) {
            //launch=true is for the instant-app
            window.location.href = `https://play.google.com/store/apps/details?id=io.cleanfox.android&launch=true&referrer=ttclid%3D${ttclid}`
        } else {
            this.$router.push({path: '/'})
        }
    },

    methods: {

        tiktokPixel() {
            /* eslint-disable */
            !async function (w, d, t) {
                w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
                ttq.load('CNLDI3RC77U696M7JTEG');
                await ttq.page();
            }(window, document, 'ttq');
            /* eslint-enable */
        },

        // tiktok code
        getCookie(name) {
            const cookie = {}
            document.cookie.split(';').forEach(function(element) {
                const [key, value] = element.split('=')
                cookie[key.trim()] = value
            })
            return cookie[name]
        }
    }
}
</script>

<style lang="scss" scoped>

.tik-tok {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
}

</style>
